// extracted by mini-css-extract-plugin
export default {"referals":"Referals_referals__a0XYR"};